<div class="title landing-hero">
  <div class="container container-max-width">
    <div class="landing-hero-text">
      <h1 class="h3">{{ pageTitle }}</h1>
      <p class="landing-subtitle">{{ pageSubtitle }}</p>
    </div>
  </div>
</div>

<div class="container container-max-width landing-content">
  <div class="row g-3">
    <div class="col-12 col-md-6 col-xl-4" *ngFor="let tile of tiles">
      <a
        *ngIf="isExternal(tile); else internalTile"
        class="landing-tile"
        [ngClass]="'accent-' + tile.accent"
        [href]="tile.externalUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ng-container *ngTemplateOutlet="tileBody; context: { $implicit: tile }"></ng-container>
      </a>

      <ng-template #internalTile>
        <a class="landing-tile" [ngClass]="'accent-' + tile.accent" [routerLink]="tile.routerLink">
          <ng-container *ngTemplateOutlet="tileBody; context: { $implicit: tile }"></ng-container>
        </a>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #tileBody let-tile>
  <div class="landing-tile-header">
    <span class="landing-tile-icon">
      <i class="fas" [ngClass]="tile.icon" aria-hidden="true"></i>
    </span>
    <h2 class="h5 landing-tile-title">{{ tile.title }}</h2>
  </div>
  <p class="landing-tile-description">{{ tile.description }}</p>
  <span class="landing-tile-cta">
    {{ tile.ctaLabel }}
    <i
      class="fas"
      [ngClass]="isExternal(tile) ? 'fa-external-link-alt' : 'fa-arrow-right'"
      aria-hidden="true"
    ></i>
    <span class="visually-hidden" *ngIf="isExternal(tile)">Opens in a new tab</span>
  </span>
</ng-template>
